<template>
    <div :id="captchaId"></div>
</template>

<script>

const api = '//www.google.com/recaptcha/api.js?hl=en&onload=onloadCaptchaCallback&render=explicit&hl=en';

export default {
    name: 'captcha',
    props: {
        captchaId: String
    },
    data() {
        return {
            theme: 'light',
            size: 'normal'
        };
    },
    beforeCreate() {
        if (window.recaptcha) return;

        window.onloadCaptchaCallback = () => {
            this.render();
        };
    },
    async created() {
        if (window.recaptcha) {
            this.$nextTick(() => {
                this.render();
            });
        } else {
            const recaptchaScript = document.createElement('script');
            recaptchaScript.setAttribute('src', api);
            document.head.appendChild(recaptchaScript);
        }
    },
    methods: {
        callback(captchaResponse) {
            this.$emit('captchaCallback', captchaResponse);
        },
        expired(captchaResponse) {
            this.$emit('captchaExpiredCallback', captchaResponse);
        },
        render() {
            try {
                // eslint-disable-next-line no-undef
                grecaptcha.render(this.captchaId, {
                    sitekey: '6LdjNhcUAAAAALR5uFOoNAON8Wzwz1zE_jt2yxLP',
                    theme: this.theme,
                    size: this.size,
                    callback: this.callback,
                    'expired-callback': this.expired
                });
            } catch (e) {
            }
        }
    }
};
</script>

<style scoped lang="scss">

</style>
